import { Image } from 'react-native';
import resizeImage from '../../utils/image/resizeImage';
import flipOnRTL from '../../utils/image/flipOnRTL';
export default resizeImage(flipOnRTL(Image));
